import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";

import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppUtil } from "@shopliftr/common-ng";
import { APP_OPTIONS } from "./app/app.options";

if (environment.production) {
    // Production mode disables Angular's development-only change detection
    // checks and assertions.
    enableProdMode();
}

/**
 * Configures the application from APP_OPTIONS and defines AppUtil.appProviders.
 * Must run before bootstrapApplication, which reads those providers.
 */
AppUtil.configureApplication(APP_OPTIONS);

bootstrapApplication(AppComponent, {
    providers: AppUtil.appProviders
})
    .catch((err) => {
        // Bootstrap failures surface only here — nothing downstream is mounted
        // yet, so there is no error handler to delegate to.
        console.error(err);
    });
